import { initialize } from 'redux-form';
import store from '../../services/store';
import updateSelectProductAction from '../../actions/select-product/update-select-product';
import removeAllUnscopedSectionsAction from '../../actions/compose-report-tool/remove-all-upscoped-sections';

const submitSelectProduct = async (data) => {
    const newData = data;
    await store.dispatch(initialize('SelectProductForm', newData, false, { keepSubmitSucceeded: true }));
    await store.dispatch(await updateSelectProductAction(newData));
    await store.dispatch(await removeAllUnscopedSectionsAction());
};

export default submitSelectProduct;
